import { defineAction } from '~/prix'
import { z } from 'zod'
import collectionIncentiveFetchAction from './collectionIncentiveFetch.action.json' with { type: 'json' }
import { collectionIncentiveObject } from '../collectionIncentiveObject'

const collectionIncentiveFetchDefinition = defineAction({
  ...collectionIncentiveFetchAction,

  input: z.object({ id: collectionIncentiveObject.shape.id }),
  output: collectionIncentiveObject,
})

export default collectionIncentiveFetchDefinition
